<template>
  <div class="tw-p-8">

    <div class="mb-2 tw-text-2xl tw-font-bold">Specify attachments related to your task or leave it blank:</div>

    <div v-if="_.get(states.task,'attachments',[]).length > 0" class="tw-grid tw-py-4 tw-divide-y tw-border-b tw-mb-5">
      <div v-for="attachment in _.get(states.task,'attachments',[])" class="tw-flex tw-items-center tw-p-4">
        <i class="bx bx-file tw-text-3xl tw-mr-2"></i>
        <div>{{attachment.name}}</div>
        <div class="tw-flex-grow"></div>
        <button v-on:click="store.deleteAttachment(attachment)"><i class="bx bx-x tw-text-dark-3 tw-text-opacity-75 tw-text-3xl"></i>
        </button>
      </div>
    </div>

    <div class="tw-grid tw-py-4 tw-divide-y">
      <div v-for="(file,index) in states.attachments" class="tw-flex tw-items-center tw-p-4">
        <i class="bx bx-file tw-text-3xl tw-mr-2"></i>
        <div>{{file.name}}</div>
        <div class="tw-flex-grow"></div>
        <button v-on:click="$delete(states.attachments,index)"><i class="bx bx-x tw-text-dark-3 tw-text-opacity-75 tw-text-3xl"></i>
        </button>
      </div>
    </div>

    <div
      v-on:click="$refs.input.click()"
      v-on:drop.prevent="handleDrop"
      v-on:dragover.prevent
      class="tw-rounded tw-bg-light-3 tw-w-full tw-h-48 tw-flex flex-center tw-my-4 tw-cursor-pointer"
    >
      <div class="tw-text-2xl">Drop a file or <span class="tw-text-blue tw-font-bold">click to select</span></div>
    </div>

    <input type="file" ref="input" multiple class="tw-hidden" v-on:change="addFile">

  </div>
</template>
<script>
  import store from './submit-task-store'

  export default {
    beforeCreate() {
      this.store = store
    },
    data: v => ({
      states: store.states,
      files: [],
    }),
    methods: {
      addFile(event) {
        let files = event.target.files;
        for (let i = 0; i < files.length; i++) {
          store.addAttachment(files.item(i))
        }
      },
      handleDrop(event) {
        // Source : https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/File_drag_and_drop
        if (event.dataTransfer.items) {
          for (let i = 0; i < event.dataTransfer.items.length; i++) {
            if (event.dataTransfer.items[i].kind === 'file') {
              store.addAttachment(event.dataTransfer.items[i].getAsFile())
            }
          }
        } else {
          for (var i = 0; i < event.dataTransfer.files.length; i++) {
            store.addAttachment(event.dataTransfer.items[i].getAsFile())
          }
        }
      },
    }
  }
</script>
